/* LevelUp 2026 — swipe carousels with arrows + dots.
   Markup: [data-lu26-carousel] > [data-lu26-track] (slides = direct children)
           optional [data-lu26-prev], [data-lu26-next], [data-lu26-dot] buttons. */
(function () {
  function setup(root) {
    if (!root || root.dataset.lu26Car) return;
    var track = root.querySelector('[data-lu26-track]');
    if (!track) return;
    root.dataset.lu26Car = '1';
    var prev = root.querySelector('[data-lu26-prev]');
    var next = root.querySelector('[data-lu26-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lu26-dot]'));

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function index() { return Math.round(track.scrollLeft / Math.max(step(), 1)); }
    function update() {
      var i = index();
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      root.dispatchEvent(new CustomEvent('lu26:slide', { detail: { index: i } }));
    }
    function go(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    root.lu26Go = go;
    update();
  }

  function all(scope) { (scope || document).querySelectorAll('[data-lu26-carousel]').forEach(setup); }
  if (document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function () { all(); });

  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-lu26-carousel]');
    if (!root || !root.lu26Go) return;
    var track = root.querySelector('[data-lu26-track]');
    var slide = e.target.closest('[data-lu26-track] > *');
    if (!track || !slide) return;
    var i = Array.prototype.indexOf.call(track.children, slide);
    if (i >= 0) root.lu26Go(i);
  });
})();
